<template>
  <div>
    <div class="subtitle-form label-heading flex-row" :class="getStatusClass(auction.status)">
      <div class="inline">
        <h3 style="margin: 0">Auction Items</h3>
      </div>
    </div>
    <div v-if="auction.items">
      <v-data-table
        :headers="tableHeaders"
        :items="auction.items"
        hide-default-footer
        class="data-table subscribers-form bidders elevation-1"
      >
        <template v-slot:item.description="{ item }">
          <v-tooltip bottom>
            <template #activator="{ on }">
              <span v-on="on">
                {{ item.description }}
              </span>
            </template>
            <span>
              {{ formatDisplayNumber(item.quantity) }}
            </span>
          </v-tooltip>
        </template>
        <template v-slot:item.quantity="{ item }">
          {{ formatDisplayNumber(item.quantity) }}
          <span v-if="item.unit">{{ item.unit.name }}</span>
        </template>
        <template v-slot:item.documentUrl="{ item }">
            <a
              v-if="item.documentUrl"
              target="_blank"
              :title="documentLabel(item)"
              :href="item.documentUrl"
              >{{ cutString(documentLabel(item), 30) }}</a
            >
            &nbsp;
            <v-tooltip bottom v-if="item.documentUrl">
              <template #activator="{ on }">
                <img
                  @click="copyToClipboard(item.documentUrl)"
                  src="../../assets/copy.png"
                  class="copy"
                  alt="Copy"
                  v-on="on"
                />
              </template>
              <div>COPY</div>
            </v-tooltip>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import { ACTIVE_TENDERING_STATUS, UNSUCCESSFUL_STATUS } from '@/constants/auction';
import { formatDisplayNumber } from '@/utils/numberFormat';
import { mapActions } from 'vuex';

export default {
  props: {
    auction: {
      type: Object,
    },
    tableHeaders: {
      type: Array,
    },
  },
  methods: {
    ...mapActions(['showSnackbar']),
    formatDisplayNumber,
    // Portal urls all begin alike, so the title is what distinguishes one
    // item's document from another's.
    documentLabel(item) {
      return item.documentTitle || item.documentUrl;
    },
    cutString(text, size) {
      if (text.length > size) {
        return text.slice(0, size) + '...';
      } else {
        return text;
      }
    },
    copyToClipboard(data) {
      let vm = this;
      this.$copyText(data).then(() => {
        vm.succesCopyToClipboard();
      });
    },
    getStatusClass(status) {
      if (status === UNSUCCESSFUL_STATUS) {
        return 'status-unsuccess';
      } else if (status === ACTIVE_TENDERING_STATUS) {
        return 'activeTendering';
      } else {
        return '';
      }
    },
    succesCopyToClipboard() {
      this.showSnackbar('COPIED');
    },
  },
};
</script>

<style lang="scss" scoped>
.bidders tr {
  position: relative;
}

h1 {
  color: #396;
  font-weight: 100;
  font-size: 40px;
  margin: 20px 0px 20px;
}
.flex-row {
  margin-top: 40px !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: space-between !important;
}
.errors-input {
  outline: 2px solid #e62a2aa3;
}
.errors-text {
  font-size: 11px;
  color: #e62a2aa3;
  margin-top: 8px;
  display: block;
}
div strong {
  font-size: 12px;
}
.align-start {
  align-items: start;
}
.label-heading {
  display: block;
  border-left: 5px solid #2e7f89;
  box-sizing: border-box;
  margin-left: -18px;
  padding-left: 14px;
}
h3 {
  text-align: left;
  color: #2e7f89;
  margin-top: 36px;
}
.subscribers-form {
  padding: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 55%;
  min-width: 900px;
  margin: 0 auto 9px auto;
  justify-content: space-between;
  flex-direction: column;
  background: #ffffff;
}
.inline {
  display: inline-block;
}
.subtitle-form {
  padding: 0 7px 0 17px;
  width: 55%;
  min-width: 900px;
  margin: 0 auto 14px auto;
  justify-content: space-between;
  flex-direction: row;
  .tbl-row,
  .tbl-row-rewerse {
    
    background: transparent;
    font-size: 9px;
    font-weight: 400;
  }
}
.strong {
  
}
.data-table td {
  text-align: left !important;
}
.tbl-row {
  width: 100%;
  text-align: left;
}
.tbl-row-rewerse {
  text-align: right;
}
.flex-center {
  display: flex;
  overflow: hidden;
}
.material-icons:hover {
  color: #2e7f89;
}
.form .card-text {
  padding: 6px 16px;
}
.card-text {
  padding: 12px 16px;
}

.copy {
  cursor: pointer;
}
@media (max-width: 1000px) {
  img {
    margin-left: 34px;
  }
  .subtitle-form {
    min-width: 90% !important;
  }
  .subscribers-form,
  .invite {
    min-width: 90% !important;
  }
}
</style>
